(function(){
"use strict";

var SUPABASE_URL="https://ycentdpkspjdrzijrbsl.supabase.co";
var SUPABASE_KEY="sb_publishable_TgKotXn3vvPpdnad_wXc9g_X1DY7arT";
var STORAGE_KEY="sb-ycentdpkspjdrzijrbsl-auth-token";
var client=null;
var editorBoundForm=null;
var editorContext=null;
var editorStyle="card_stack";
var publicBusy=false;

function route(){return location.hash.split("?")[0];}
function getClient(){
  if(client)return client;
  if(!window.supabase||!window.supabase.createClient)return null;
  client=window.supabase.createClient(SUPABASE_URL,SUPABASE_KEY,{
    auth:{persistSession:true,autoRefreshToken:false,detectSessionInUrl:false,storageKey:STORAGE_KEY}
  });
  return client;
}
function anim(el,frames,opts){
  if(!el)return Promise.resolve();
  if(el.animate){
    try{return el.animate(frames,opts).finished.catch(function(){});}catch(e){}
  }
  var last=frames[frames.length-1]||{};
  Object.keys(last).forEach(function(k){try{el.style[k]=last[k];}catch(e){}});
  return new Promise(function(resolve){setTimeout(resolve,opts.duration||0);});
}
function resetPreview(preview){
  if(!preview)return;
  preview.querySelectorAll(".sell-banner").forEach(function(x){
    x.classList.remove("kp-public-card-stack");
    try{x.getAnimations().forEach(function(a){a.cancel();});}catch(e){}
    x.style.removeProperty("transform");
    x.style.removeProperty("opacity");
    x.style.removeProperty("clip-path");
  });
  preview.querySelectorAll(".kp-gold-sweep").forEach(function(x){x.remove();});
  if(preview.classList&&preview.classList.contains("kp-golden-reveal-host"))preview.classList.remove("kp-golden-reveal-host");
  preview.querySelectorAll(".kp-golden-reveal-host").forEach(function(x){x.classList.remove("kp-golden-reveal-host");});
}
function runBannerAnimation(root,style){
  if(!root)return;
  var banner=root.matches&&root.matches(".sell-banner")?root:root.querySelector(".sell-banner");
  if(!banner)return;
  resetPreview(root);

  if(style==="none")return;
  if(style==="card_stack"){
    banner.classList.add("kp-public-card-stack");
    anim(banner,[
      {transform:"translateY(26px) rotate(-2.3deg) scale(.955)",opacity:0},
      {transform:"translateY(-3px) rotate(.5deg) scale(1.01)",opacity:1,offset:.78},
      {transform:"translateY(0) rotate(0deg) scale(1)",opacity:1}
    ],{duration:820,easing:"cubic-bezier(.22,1,.36,1)",fill:"both"});
    return;
  }
  if(style==="golden_reveal"){
    var host=banner.closest(".sell-hero")||banner.parentElement;
    if(host)host.classList.add("kp-golden-reveal-host");
    var sweep=document.createElement("div");sweep.className="kp-gold-sweep";
    if(host)host.appendChild(sweep);
    anim(banner,[
      {clipPath:"inset(0 100% 0 0)",opacity:.4},
      {clipPath:"inset(0 0% 0 0)",opacity:1}
    ],{duration:760,easing:"cubic-bezier(.22,1,.36,1)",fill:"both"});
    anim(sweep,[
      {transform:"translateX(-120%)"},
      {transform:"translateX(120%)"}
    ],{duration:900,easing:"cubic-bezier(.4,0,.2,1)",fill:"both"}).then(function(){sweep.remove();});
    return;
  }
  if(style==="editorial"){
    var bits=[
      banner.querySelector(".role"),
      banner.querySelector(".sell-banner-left h1, .sell-banner-left h2, .sell-banner-left h3"),
      banner.querySelector(".bio"),
      banner.querySelector(".sell-actions"),
      banner.querySelector(".avatar"),
      banner.querySelector(".sb-qr")
    ].filter(Boolean);
    bits.forEach(function(el,i){
      anim(el,[
        {transform:"translateY(18px)",opacity:0},
        {transform:"translateY(0)",opacity:1}
      ],{duration:520,delay:i*95,easing:"cubic-bezier(.22,1,.36,1)",fill:"both"});
    });
    return;
  }
  if(style==="soft_fade"){
    anim(banner,[
      {transform:"translateY(14px) scale(.99)",opacity:0},
      {transform:"translateY(0) scale(1)",opacity:1}
    ],{duration:760,easing:"ease-out",fill:"both"});
  }
}
function pickerMarkup(){
  var opts=[
    ["card_stack","🗂️","Card Stack","Kort med djup och rörelse"],
    ["golden_reveal","✨","Golden Reveal","Guldig svep-övergång"],
    ["editorial","✍️","Editorial","Text kommer in stegvis"],
    ["soft_fade","☁️","Soft Fade","Lugn och mjuk entré"],
    ["none","○","Ingen","Helt statisk sida"]
  ];
  return '<section class="kp-anim-picker" id="kp-sell-animation-picker">'+
    '<div class="kp-anim-picker-head"><div><h3>Animation</h3><p>Välj hur din publika säljsida ska kännas när någon öppnar den.</p></div><div class="kp-anim-head-actions"><span class="kp-anim-live">Live-preview</span><button type="button" class="kp-anim-replay" data-kp-replay>↻ Spela igen</button></div></div>'+
    '<div class="kp-anim-options">'+opts.map(function(o){
      return '<button type="button" class="kp-anim-option" data-kp-anim="'+o[0]+'"><span class="ico">'+o[1]+'</span><b>'+o[2]+'</b><span>'+o[3]+'</span></button>';
    }).join("")+'</div>'+
    '<div class="kp-anim-picker-foot"><small>Card Stack är standard. Valet sparas tillsammans med säljsidan.</small><span class="kp-anim-save-note" aria-live="polite"></span></div>'+
  '</section>';
}
function setSelected(panel,style,preview,play){
  editorStyle=style||"card_stack";
  panel.querySelectorAll("[data-kp-anim]").forEach(function(b){
    b.classList.toggle("active",b.dataset.kpAnim===editorStyle);
    b.setAttribute("aria-pressed",b.dataset.kpAnim===editorStyle?"true":"false");
  });
  if(play)runBannerAnimation(preview,editorStyle);
}
async function loadEditorContext(){
  var sb=getClient();if(!sb)return null;
  var p=await sb.rpc("get_portal_context_v27",{p_group_id:null});
  if(p.error||!p.data||!p.data.has_group)return null;
  var gid=p.data.group&&p.data.group.id;
  var settings={};
  if(gid){
    var s=await sb.rpc("get_my_sell_page_settings_v1",{p_group_id:gid});
    if(!s.error&&s.data)settings=s.data;
  }
  return {groupId:gid,portal:p.data,settings:settings};
}
function currentFormValues(form){
  function val(id){var el=form.querySelector("#"+id);return el?String(el.value||"").trim():"";}
  var qr=form.querySelector("#se-show-qr");
  return {
    headline:val("se-headline"),
    intro:val("se-intro"),
    theme:val("se-theme")||"gold",
    layout:val("se-layout")||"classic",
    show_qr:qr?!!qr.checked:true,
    animation_style:editorStyle||"card_stack"
  };
}
async function saveEditor(e,form,panel){
  e.preventDefault();
  e.stopImmediatePropagation();
  var note=panel.querySelector(".kp-anim-save-note");
  var btn=form.querySelector('button[type="submit"]');
  var values=currentFormValues(form);
  if(!values.headline){
    note.textContent="Skriv en rubrik först.";
    note.style.color="#B42318";
    return;
  }
  var sb=getClient();
  if(!sb){note.textContent="Kunde inte ansluta.";note.style.color="#B42318";return;}
  if(!editorContext)editorContext=await loadEditorContext();
  if(!editorContext||!editorContext.groupId){
    note.textContent="Kunde inte hitta gruppen.";
    note.style.color="#B42318";
    return;
  }
  if(btn)btn.disabled=true;
  note.textContent="Sparar…";note.style.color="";
  try{
    var save=await sb.rpc("save_sell_page_settings_v1",{p_group_id:editorContext.groupId,p_settings:values});
    if(save.error)throw save.error;
    var user=await sb.auth.getUser();
    if(user&&user.data&&user.data.user){
      var md=Object.assign({},user.data.user.user_metadata||{},{sell_page_settings:save.data});
      await sb.auth.updateUser({data:md});
    }
    editorContext.settings=save.data||values;
    note.textContent="Sparat ✓";note.style.color="#067647";
  }catch(err){
    note.textContent=(err&&err.message)||"Kunde inte spara.";
    note.style.color="#B42318";
  }finally{
    if(btn)btn.disabled=false;
  }
}
async function bindEditor(){
  if(route()!=="#/sell-editor")return;
  var form=document.querySelector("#sell-editor-form");
  var preview=document.querySelector("#sell-editor-preview");
  if(!form||!preview)return;
  if(editorBoundForm===form)return;
  editorBoundForm=form;

  var panel=document.createElement("div");
  panel.innerHTML=pickerMarkup();
  panel=panel.firstElementChild;
  var actions=form.querySelector(".form-actions");
  if(actions)form.insertBefore(panel,actions);
  else form.appendChild(panel);

  editorContext=await loadEditorContext();
  var initial=(editorContext&&editorContext.settings&&editorContext.settings.animation_style)||"card_stack";
  setSelected(panel,initial,preview,true);

  panel.addEventListener("click",function(e){
    var replay=e.target.closest&&e.target.closest("[data-kp-replay]");
    if(replay){
      runBannerAnimation(preview,editorStyle);
      var replayNote=panel.querySelector(".kp-anim-save-note");
      replayNote.textContent="Spelar animationen igen";
      replayNote.style.color="";
      return;
    }
    var b=e.target.closest&&e.target.closest("[data-kp-anim]");
    if(!b)return;
    setSelected(panel,b.dataset.kpAnim,preview,true);
    var note=panel.querySelector(".kp-anim-save-note");
    note.textContent="Valt: "+b.querySelector("b").textContent;
    note.style.color="";
  });

  form.addEventListener("submit",function(e){saveEditor(e,form,panel);},true);

  var previewTimer=null;
  function schedulePreview(){
    if(previewTimer)clearTimeout(previewTimer);
    previewTimer=setTimeout(function(){
      if(route()!=="#/sell-editor"||!document.body.contains(preview))return;
      if(preview.querySelector(".sell-banner"))runBannerAnimation(preview,editorStyle);
    },40);
  }
  form.addEventListener("input",schedulePreview);
  form.addEventListener("change",schedulePreview);
}
async function applyPublic(){
  var r=route();
  if(r.indexOf("#/s/")!==0||publicBusy)return;
  var token=decodeURIComponent(r.slice(4));
  var banner=document.querySelector(".sell-banner");
  if(!token||!banner||banner.dataset.kpPublicAnimApplied)return;
  publicBusy=true;
  try{
    var sb=getClient();
    var style="card_stack";
    if(sb){
      var res=await sb.rpc("get_public_seller_animation_v1",{p_seller_token:token});
      if(!res.error&&res.data)style=res.data;
    }
    banner.dataset.kpPublicAnimApplied=style;
    runBannerAnimation(document,style);

    var cards=[].slice.call(document.querySelectorAll("#products-public .product-card"));
    if(style==="card_stack"){
      cards.forEach(function(c,i){anim(c,[{transform:"translateY(22px) rotate(-1deg)",opacity:0},{transform:"translateY(0) rotate(0)",opacity:1}],{duration:560,delay:260+i*80,easing:"cubic-bezier(.22,1,.36,1)",fill:"both"});});
    }else if(style==="editorial"){
      cards.forEach(function(c,i){anim(c,[{transform:"translateY(18px)",opacity:0},{transform:"translateY(0)",opacity:1}],{duration:500,delay:500+i*70,easing:"ease-out",fill:"both"});});
    }else if(style==="soft_fade"){
      [document.querySelector("#customer-delivery-info"),document.querySelector("#products-public .sec-head")].concat(cards).filter(Boolean).forEach(function(el,i){
        anim(el,[{transform:"translateY(12px)",opacity:0},{transform:"translateY(0)",opacity:1}],{duration:620,delay:180+i*70,easing:"ease-out",fill:"both"});
      });
    }
  }finally{
    publicBusy=false;
  }
}
function sync(){
  if(route()==="#/sell-editor")bindEditor();
  else if(route().indexOf("#/s/")===0)applyPublic();
  else{editorBoundForm=null;editorContext=null;}
}
window.addEventListener("hashchange",function(){setTimeout(sync,120);});
var app=document.getElementById("app");
if(app&&window.MutationObserver)new MutationObserver(function(){setTimeout(sync,70);}).observe(app,{childList:true,subtree:true});
setTimeout(sync,500);
})();